import { Injectable } from '../ng';

@Injectable()
export class SCurveService {

    constructor() {

    }

    getSecondValueForDate(chartData: any, model: any) {
        let projectedData = chartData.find(x => x.name == "Projected").series.filter(x => x.name == model[0].name);
        let lastProjectedValue = projectedData ? projectedData[projectedData.length - 1] : null;
        if (lastProjectedValue != null)
            model.find(x => x.series == "Projected").value = lastProjectedValue.value;
        return model;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/scurve.service.ts